module.exports = (function () {
    getRootWindow = function (config) {
        var res = window;
        if (config && config.topView) return config.topView;
        if (config && config.showModalPopUp) return res;

        while (res && res.parent && res.parent != res) {
            // TODO: here we should detect "top-mos-window" and stop drilling (even if we have more parents!)
            res = res.parent;
        }
        return res;
    }

    var getRootWindowInSameDomain = function (config) {
        var top = window;
        var win = window;
        if (config && config.topView) return config.topView;
        if (config && config.showModalPopUp) return top;
        
        while (win.parent != win) {
          try {
            // when the parent window is from a different domain accessing any property from window will throw cross origin access exception
            if(win.parent.document) {
                top = win.parent;
            }
          } catch (e) {}
            win = win.parent;
        }
        return top;
    }

    createAndShowModalFrame = function (rootWindow, contextId) {
        
        var pathToHtml = window.location.origin + window.location.pathname.split('/').filter(function(word) { return word !== 'index.html';}).join('/');

        $(rootWindow.document.body).append(
            '<div id="' + contextId + '" style="background-color: rgba(0,0,0,.6); box-sizing:content-box; position:fixed; z-index:1000;top:0px;bottom:0px;left:0px;right:0px; border:0px; overflow:hidden;">'
            + '<div id="loading_' + contextId + '" style="display:block;position:absolute; left:50%; top:50%; right:0px; bottom:0px;"><div style="box-sizing:content-box;width:130px; margin-left:-100px; margin-top:-30px;background-color:#f0f0f0; padding:20px 20px 20px 50px; border-radius:5px;"><span class="spinner spinner-inline"></span><span>&nbsp;&nbsp;Loading...</span></div></div>'
            + '<iframe id="frm-' + contextId + '" name="' + contextId + '" src="' + pathToHtml + 'fullscreen-overlay.html" frameborder=0 style="display:none; margin:0px; position:absolute; top:0px; right:0px; left:0px; width:100%; height:100%; background-color:transparent;border:0px;"></iframe></div>'
        );
    }

    return {

        displayFullScreenOverlay: function (viewUrl, config) {

            if (!config) config = {};
            if (!viewUrl && config) viewUrl = config.url;

            var contextId = (config.lockId || 'a') + '-' + new Date().getTime();
            var rootWindow = getRootWindowInSameDomain(config);
            config.url = viewUrl;
            config.contextId = contextId;
            var view = { id: contextId };
            rootWindow[contextId] = view; // XXX simple, but not good!
            view.config = config;

             console.log("fullscreenOverlayHost.js viewUrl: " + viewUrl);

            view.done = function (response) {

                //$('#'+contextId, rootWindow.document.body).remove();
                var frameContainer = rootWindow.document.getElementById(contextId);
                frameContainer.parentNode.removeChild(frameContainer);
                delete rootWindow[contextId];

                // if (config && config.lockId) {
                //     delete $rootScope.$runTopLocks[config.lockId];
                // }

                setTimeout(function () {
                    // TODO: should we refresh something?
                    //if (result == "OK") getHybridServicesConfigurations('reload');
                    if (config && config.finally) {
                        config.finally(response);
                    }
                }, 100);
            }

            view.show = function () {
                view.visible = true;
                //$('#'+contextId, rootWindow.document.body).css({'visibility':'visible'});
                var frameContainer = rootWindow.document.getElementById(contextId);
                frameContainer.style.visibility = 'visible';
                var banner = rootWindow.document.getElementById('loading_' + contextId);
                banner.style.display = 'none';
                var frameContainer = rootWindow.document.getElementById('frm-' + contextId);
                frameContainer.style.display = 'block';
                //view.hideBanner = true;
            }

            view.hide = function () {
                view.visible = false;
                //$('#'+contextId, rootWindow.document.body).css({'display':'none'});
                var frameContainer = rootWindow.document.getElementById(contextId);
                frameContainer.style.visibility = 'hidden';

                // XXX we will clean up locking when modal is hidden,
                //     but that allows modal to be shown again and break locking
                if (config && config.lockId) {
                    delete $rootScope.$runTopLocks[config.lockId];
                }
            }

            view.loadDialogContent = function () {
                var frameContainer = rootWindow.document.getElementById('frm-' + contextId);
                frameContainer.src = view.url
            }

            function getViewUrl(url) {
                if (!url) return null;
                // XXX this 'search and hash' transfering is not straightforward!
                //     1) viewUrl could came with params
                //     2) viewUrl could be absolute
                //     3) viewUrl could have different parametres
                // we do this for keepping session & context params...
                var urlParams = window.location.search;
                var urlHash = window.location.hash;
                if (config.params) {
                    var newParams = angular.extend(angular.copy($location.search()), config.params);
                    urlParams = "?" + $httpParamSerializer(newParams);
                }
                return url + urlParams + urlHash;
            }

            createAndShowModalFrame(rootWindow, contextId);
        }
    }
})();





//////////////////
// WEBPACK FOOTER
// ./src/auditlog/src/auditlog-ui/utils/fullScreenOverlayHost.js
// module id = 1fhA
// module chunks = 0